import React, { Component } from 'react';
import { Badge, Button, Container, Content, Header, Left, Right, Body, Title, Text, List, ListItem, Picker, View } from 'native-base';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { Font, AppLoading } from 'expo';
import { Image, StyleSheet } from 'react-native';
// import { sideMenuStyle } from './../../assets/styles/styles';
import { Dimensions } from 'react-native';
import {translations as t} from '../constants/translations';
import {connect} from "react-redux";
import {setAppRegion} from "../actions";
import PropTypes from "prop-types";

export const sideMenuStyle = StyleSheet.create({
    buttons: {
        fontSize: 15
    },
    woBorderBottom:{
        borderBottomWidth: 0
    },
    tienda:{
        fontFamily: 'sans-serif',
        // fontFamily: 'DancingScriptRegular', adgem
        fontSize: 25,
        color: '#752384'
    },
    tiendaIcon:{
        color: '#752384'
    },
    mainContainer:{
        paddingTop: 20,
        backgroundColor: '#e2051c',
    },
    logo:{
        width: Dimensions.get('window').width * .75,
        height: 100
    },
    contentStyle:{
        backgroundColor: '#ffffff'
    }
});

class SideMenu extends Component{
    constructor(props){
        super(props);
    }

    state ={ 
        selected: "RU",
      }

    handleItemPress = () => {
        console.log("Dnevnik press");
    }
    handlerLanguageChange = () => {
        let setRegion = this.props.appRegion === 'RU' ? 'EN' : 'RU';
        this.props.dispatch(setAppRegion(setRegion));
    }

    onValueChange (value) {
        const { dispatch } = this.props;
        this.setState({
          ...this.state, selected : value
        });
  
        this.state.selected === "RU" ? dispatch(setAppRegion("EN")) : dispatch(setAppRegion("RU"));
    }

    render(){
        const {appRegion} = this.props;
        return (
          <View>
             <Picker
                selectedValue={this.state.selected}
                onValueChange={this.onValueChange.bind(this)}
                style={{width:50, borderRadius: 25, marginLeft: 5,}}>
                <Picker.Item label="RU" value="RU"/>
                <Picker.Item label="EN" value="EN"/>
             </Picker>    
          </View>
            // // <Container style={sideMenuStyle.mainContainer}>
            //     {/* <Content style={sideMenuStyle.contentStyle}> */}
            //         {/* <Image style={sideMenuStyle.logo} resizeMode="cover" source={require('./../../assets/img/logo.jpg')}/>
            //         <List>
            //             <ListItem icon onPressIn={()=>{this.handleItemPress()}}>
            //                 <Left>
            //                     <Icon name="account-circle" style={sideMenuStyle.buttons} />
            //                 </Left>
            //                 <Body>
            //                     <Text>{t[appRegion]['SIDEMENU_ITEM_JOURNAL']}</Text>
            //                 </Body>
            //                 <Right>
            //                     <Icon name="arrow-forward" style={sideMenuStyle.buttons} />
            //                 </Right>
            //             </ListItem>
            //             <ListItem icon>
            //                 <Left>
            //                     <Icon name="event" style={sideMenuStyle.buttons} />
            //                 </Left>
            //                 <Body style={sideMenuStyle.woBorderBottom}>
            //                     <Text>{t[appRegion]['SIDEMENU_ITEM_DOCTORDLIST']}</Text>
            //                 </Body>
            //                 <Right style={sideMenuStyle.woBorderBottom}>
            //                     <Icon name="arrow-forward" style={sideMenuStyle.buttons} />
            //                 </Right>
            //             </ListItem>
            //             <ListItem icon>
            //                 <Left>
            //                     <Icon name="book" style={sideMenuStyle.buttons} />
            //                 </Left>
            //                 <Body style={sideMenuStyle.woBorderBottom}>
            //                     <Text>Cuadernos</Text>
            //                 </Body>
            //                 <Right style={sideMenuStyle.woBorderBottom}>
            //                     <Icon name="arrow-forward" style={sideMenuStyle.buttons} />
            //                 </Right>
            //             </ListItem>
            //             <ListItem icon>
            //                 <Left>
            //                     <Icon name="stars" style={sideMenuStyle.buttons} />
            //                 </Left>
            //                 <Body style={sideMenuStyle.woBorderBottom}>
            //                     <Text>Outlet</Text>
            //                 </Body>
            //                 <Right style={sideMenuStyle.woBorderBottom}>
            //                     <Icon name="arrow-forward" style={sideMenuStyle.buttons} />
            //                 </Right>
            //             </ListItem>
            //             <ListItem icon onPressIn={()=>this.handlerLanguageChange()}>
            //                 <Left>
            //                     <Icon name="shopping-basket" style={[sideMenuStyle.buttons, sideMenuStyle.tiendaIcon]} />
            //                 </Left>
            //                 <Body style={sideMenuStyle.woBorderBottom}>
            //                     <Text style={sideMenuStyle.tienda}>{t[appRegion]['SIDEMENU_ITEM_LANGUAGE']}</Text>
            //                 </Body>
            //                 <Right style={sideMenuStyle.woBorderBottom}>
            //                     <Icon name="arrow-forward" style={[sideMenuStyle.buttons, sideMenuStyle.tiendaIcon]} />
            //                 </Right>
            //             </ListItem>
            //         </List> */}
            //     {/* </Content> */}
            // // </Container>
        );
    }
}

SideMenu.propTypes = {
    dispatch: PropTypes.func.isRequired,
    appRegion: PropTypes.object,
};
const mapStateToProps = (state) => ({
    appRegion: state.appRegion
});

export default connect(mapStateToProps)(SideMenu);